export const RMS_ACTIVITY_OPTIONS = [
    { value: 0, label: "Low" },
    { value: 1, label: "High" },
];

export const RMS_SOURCE_OPTIONS = [
    { value: 1, label: "Dry Sense" },
    { value: 2, label: "Rectifier" },
    { value: 3, label: "Logical" },
];

export function getRmsSourceKey(portKey) {
    if (portKey.startsWith("unknown_")) {
        return `${portKey.replace("unknown_", "unknown")}_source`;
    }
    return `${portKey}_source`;
}

export const RMS_PORT_ROWS_LEFT = [
    { key: "door_open", label: "1. Door Open" },
    { key: "mains_fail", label: "2. MAINS FAIL" },
    { key: "dc_low", label: "3. DC LOW" },
    { key: "rectifier_fault", label: "4. RECTIFIER FAULT" },
    { key: "water_leakage", label: "5. WATER LEAKAGE" },
    { key: "odc_temp_high", label: "6. ODC Temperature" },
    { key: "smoke", label: "7. SMOKE" },
    { key: "dc_fan_fault", label: "8. DC FAN FAULT" },
    { key: "mdb_fault", label: "9. MDB Fault" },
    { key: "llvd", label: "10. LLVD" },
    { key: "unknown_1", label: "11. Phase-R", subLabel: "unknown_1" },
    { key: "unknown_2", label: "12. Phase-Y", subLabel: "unknown_2" },
    { key: "unknown_3", label: "13. Phase-B", subLabel: "unknown_3" },
];

export const RMS_PORT_ROWS_RIGHT = [
    { key: "bat_load_fuse_fault", label: "14. Batt/Load Fuse Fault" },
    { key: "aviation_light_fault", label: "15. AVIATION LIGHT FAULT" },
    { key: "pg_status", label: "16. PG Running" },
    { key: "unknown_4", label: "17. Unknown-4" },
    { key: "unknown_5", label: "18. Unknown-5" },
    { key: "unknown_6", label: "19. Unknown-6" },
    { key: "unknown_7", label: "20. Unknown-7" },
    { key: "unknown_8", label: "21. Unknown-8" },
    { key: "unknown_9", label: "22. Unknown-9" },
    { key: "unknown_10", label: "23. Unknown-10" },
    { key: "unknown_11", label: "24. Motion" },
];

export const RMS_OTHER_FIELDS = [
    {
        name: "acm_allow",
        label: "ACM Allow",
        type: "select",
        options: [
            { value: 0, label: "No" },
            { value: 1, label: "Yes" },
        ],
    },
    {
        name: "phase_type",
        label: "Phase Type",
        type: "select",
        options: [
            { value: 1, label: "1-Phase" },
            { value: 3, label: "3-Phase" },
        ],
    },
    {
        name: "voltage_source",
        label: "Voltage Source",
        type: "select",
        options: [
            { value: 0, label: "—" },
            { value: 1, label: "Battery" },
            { value: 2, label: "Rectifier" },
            { value: 3, label: "Colo Cabinate" },
        ],
    },
    {
        name: "current_source",
        label: "Current Source",
        type: "select",
        options: [
            { value: 0, label: "—" },
            { value: 1, label: "Device OR CT" },
            { value: 2, label: "Rectifier" },
            { value: 3, label: "Colo Cabinate" },
        ],
    },
    {
        name: "temperature_source",
        label: "Temperature Source",
        type: "select",
        options: [
            { value: 0, label: "—" },
            { value: 1, label: "Same Cabinate" },
            { value: 2, label: "Diffrent Cabinate" },
        ],
    },
    {
        name: "temp",
        label: "Temperature",
        type: "number",
        hint: "When temperature exceeds this value, a Temperature High alarm is generated.",
    },
    {
        name: "temperature_alarm_enable",
        label: "Temperature Alarm Enable",
        type: "select",
        options: [
            { value: 0, label: "No" },
            { value: 1, label: "Yes" },
        ],
    },
    {
        name: "battery_high",
        label: "MDB fault (V)",
        type: "number",
        step: "0.1",
        hint: "When battery voltage falls below this value, an MDB Fault alarm is generated.",
    },
    {
        name: "battery_low",
        label: "Battery Low (V)",
        type: "number",
        step: "0.1",
        hint: "When battery voltage falls below this value, a DC LOW alarm is generated.",
    },
    {
        name: "ct_value",
        label: "LLVD (A)",
        type: "number",
        hint: "When load current falls below this value, an LLVD alarm is generated.",
    },
];

export const RMS_SECTIONS = [
    { id: "ports", title: "Port Configuration", icon: "fa-light fa-plug" },
    { id: "other", title: "Other Configuration", icon: "fa-light fa-sliders" },
];
